export default __webpack_public_path__ + "static/media/studio-2.6fe3aba0.jpg";